/* RESPONSIBLE TEAM: team-frontend-tech */
import PromiseProxyMixin from '@ember/object/promise-proxy-mixin';
import ArrayProxy from '@ember/array/proxy';
import SortableMixin from 'embercom/lib/sortable-mixin';
export default ArrayProxy.extend(PromiseProxyMixin, SortableMixin);
